module.exports = __webpack_public_path__ + "img/map-desktop.30204306.png";